<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">
                    Policy Statement
                    <div id="hero-sub-text">and</div>
                    Terms & Conditions
                </h1>
            </div>
        </div>

        <div class="container pt-6 pb-8">
            <div class="mb-5">
                <h2 class="display-3">Welcome to <span class="text-danger inline">Cutiefy!</span></h2>
                <p>Please read these terms carefully before using the platform /site or services offered. By accessing or using this site and/or our services in any manner, you or the entity you represent agree that you have read, agree to comply and be bound by and be a party to the terms and conditions of this agreement and our privacy policy to the exclusion of all other terms. If you do not unconditionally agree to all the terms and conditions of the agreement, please refrain from using this platform/site or our services.</p>
                <p>This site is not for use by any minors (those who are below 18 years old). Please refrain from using this site if you are a minor. The term 'Cutiefy Marketing Services' or ‘Cutiefy’ or 'us' or 'we' refers to the owner of this Platform whose registered office is UB, 111 Paseo de Roxas St., Legaspi Village, Makati City 1229 Philippines, duly registered company in the Philippines. The term 'you' refers to the user or viewer of our site.</p>
            </div>
            <terms-and-conditions-section />
        </div>
    </div>
</template>
<script>
import { resource } from "@utils/network";
import TermsAndConditionsSection from "./partials/TermsAndConditionsSection";

export default {
    name: "PolicyStatementPage",
    components: { TermsAndConditionsSection },
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/about-us-header.jpg") }')`;
        }
    },
}
</script>
<style lang="css" scoped>
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
        background-position-x: 50%;
    }
    #hero-text {
        margin: 360px 0 0 0;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-sub-text {
        margin-top: -20px;
        margin-bottom: -20px;
        font-family: 'Open Sans', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
    h2.display-3,
    h2.display-4 {
        font-family: 'Montserrat', sans-serif;
    }
    #tac-of-user-container .item-list .item-list {
        list-style: decimal;
        list-style-type: decimal;
    }
    /* ol:not(.sublist) { counter-reset: item } */
    #tac-of-user-container ol.item-list { counter-reset: item }
    #tac-of-user-container .sublist li{ display: block }
    #tac-of-user-container ol li .display-4 {
        display: inline-block;
        max-width: 98%;
    }
    #tac-of-user-container li:before {
        content: counters(item, ".") ". ";
        counter-increment: item;
        margin-left: -54px;
        margin-right: 4px;
        width: 50px;
        text-align: right;
        display: inline-block;
    }
</style>